import React from 'react';
import styled from 'styled-components';
import { useState, useEffect } from 'react';
import moment from "moment";
import "moment/locale/ko";
import 'react-dates/initialize';
import { SingleDatePicker } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import DaumPostcode from 'react-daum-postcode';
import Select from 'react-select';
import Modal from 'react-modal';
import SelectDropDownBtn from '../common/button/SelectDropDownBtn';
import { useSelector, useDispatch } from 'react-redux';
import { EsApplyInfoDao, setEsApplyInfoAction } from '../../modules/es/esApplyModule';
import TextArea from '../common/textarea/TextArea';
import NormalInput from '../common/input/NormalInput';
import { createRef } from 'react';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        zIndex: '999',
    },
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        zIndex: '1000'
    }

};
const EsApplyDvryCompBlock = styled.div`
    .item-input2 {
        padding: 0 15px 0 15px;
    }
`;

const DatepickerBlock = styled.div`

    .CalendarDay {
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        cursor: pointer;
        font-size: 14px;
        text-align: center;
        vertical-align: middle
    }

    .CalendarDay__selected,
    .CalendarDay__selected:active,
    .CalendarDay__selected:hover {
    background: #ffc742;
    border: 1px solid #ffc742;
    color: #fff;
    }

    .SingleDatePickerInput {
        border-radius: 4px;
        border: 1px solid #ccc;
        font-size: 14px;
        padding: 5px;
        height: 40px;
        vertical-align: middle;
    }

    .SingleDatePickerInput__withBorder {
        border: 1px solid  ${props => props.focused ? '#ffc742' : '#dbdbdb'};
        height: 40px;
        padding: 0px 5px 0px;
    }

    .DateInput_input {
        padding: 0px;
        vertical-align: middle;
        font-size: 14px;
    }
    .DateInput_input__focused {
        border-bottom: 0px;
    }

    .SingleDatePickerInput_calendarIcon {
        padding: 5px;
    }

`;

const CustomInputIcon = ({ onClick }) => (
    <div
        style={{
            width: "28px",
            height: "28px",
            backgroundImage: `url(/assets/images/icon/calendar-icon.png)`
        }}
        onClick={onClick}
    />
);

// 면적 옵션 
let areaOptions = [];

const placeOptions = [
    { value: 1, label: "원룸&오피스텔" },
    { value: 2, label: "아파트" },
    { value: 3, label: "빌라&연립" },
    { value: 4, label: "단독주택" },
    { value: 5, label: "사무공간" },
    { value: 6, label: "상업공간" },
    { value: 7, label: "기타" }
];


Modal.setAppElement('#modal-root');

/**
 * 견적 작성의 배송 정보 
 */
const EsApplyDvryComp = ({ isBtnShow = false }) => {

    const dispatch = useDispatch();

    const [focused, setFocused] = useState(false);
    const [date, setDate] = useState(moment().add(14, "days"));
    const [openModal, setOpenModal] = useState(false);
    const [postNum, setPostNum] = useState("");
    const [addr, setAddr] = useState("");
    const [area, setArea] = useState(0);
    const [place, setPlace] = useState(0);
    const [areaType, setAreaType] = useState(1);
    const [priceConfirm, setPriceConfirm] = useState(1);
    const [question, setQuestion] = useState("");
    const [addr2, setAddr2] = useState("");

    moment.locale('ko');

    const { esApplyInfo } = useSelector(
        ({ esApplyReducer, userReducer }) => ({
            esApplyInfo: esApplyReducer.esApplyInfo
        })
    );

    useEffect(() => {
        if (areaOptions.length === 0) {
            let i = 5;
            while (i < 56) {
                let option = { value: i, label: i + "평" };
                areaOptions.push(option)
                i++;
            }
        }

        // [SAVE REDUX START]
        let applyinfo = esApplyInfo;
        if (applyinfo === null) {
            applyinfo = EsApplyInfoDao();
        }
        // console.log("date : " + JSON.stringify(date))
        applyinfo.dsrd_date = date;
        dispatch(setEsApplyInfoAction(applyinfo));
        // [SAVE REDUX END]

    }, [])

    // Date Picker 에서 날짜 변경 
    const onDateChange = (date) => {
        setDate(date);
        // [SAVE REDUX START]
        let applyinfo = esApplyInfo;
        if (applyinfo === null) {
            applyinfo = EsApplyInfoDao();
        }
        applyinfo.dsrd_date = date;
        dispatch(setEsApplyInfoAction(applyinfo));
        // [SAVE REDUX END]
    }

    // date picker 에서 포커서 변경
    const onFocusChange = (isFocused) => {
        setFocused(isFocused.focused);
    }

    // 주소 찾기 
    const onOpenModal = () => {
        setOpenModal(true);
    }

    // Modal 닫기 
    const onCloseModal = () => {
        setOpenModal(false);
    }

    // 주소 찾기 완료 
    const handleSearchComplete = (data) => {
        let fullAddress = data.address;
        let extraAddress = '';

        // console.log("data : " + JSON.stringify(data));
        setPostNum(data.zonecode);

        if (data.addressType === 'R') {
            if (data.bname !== '') {
                extraAddress += data.bname;
            }
            if (data.buildingName !== '') {
                extraAddress += (extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName);
            }
            fullAddress += (extraAddress !== '' ? ` (${extraAddress})` : '');
        }

        setAddr(fullAddress);

        // [SAVE REDUX START]
        let applyinfo = esApplyInfo;
        if (applyinfo === null) {
            applyinfo = EsApplyInfoDao();
        }
        applyinfo.zipcode = data.zonecode;
        applyinfo.addr1 = fullAddress;
        dispatch(setEsApplyInfoAction(applyinfo));
        // [SAVE REDUX END]

        onCloseModal();
        // console.log(fullAddress);  // e.g. '서울 성동구 왕십리로2길 20 (성수동1가)'
    }

    // 평수 선택 
    const handleAreaChange = (param) => {
        setArea(param.value);

        // [SAVE REDUX START]
        let applyinfo = esApplyInfo;
        if (applyinfo === null) {
            applyinfo = EsApplyInfoDao();
        }
        applyinfo.area_size = param.value + "평";
        dispatch(setEsApplyInfoAction(applyinfo));
        // [SAVE REDUX END]

        // console.log("handleAreaChange : " + JSON.stringify(param));
    }

    // 주거형태 선택
    const handlePlaceChange = (param) => {
        setPlace(param.value);

        // [SAVE REDUX START]
        let applyinfo = esApplyInfo;
        if (applyinfo === null) {
            applyinfo = EsApplyInfoDao();
        }
        applyinfo.house_type = "05530" + param.value;
        dispatch(setEsApplyInfoAction(applyinfo));
        // [SAVE REDUX END]

        // console.log("handlePlaceChange : " + JSON.stringify(param));
    }

    const handleAreaType = () => {

        // [SAVE REDUX START]
        let applyinfo = esApplyInfo;
        if (applyinfo === null) {
            applyinfo = EsApplyInfoDao();
        }
        applyinfo.area_type = "05520" + (areaType === 1 ? "0" : "1");
        dispatch(setEsApplyInfoAction(applyinfo));
        // [SAVE REDUX END]
        setAreaType(areaType === 1 ? 0 : 1);
    }

    // 설치 비용 확인 
    const handlePriceConfirm = () => {

        // [SAVE REDUX START]
        let applyinfo = esApplyInfo;
        if (applyinfo === null) {
            applyinfo = EsApplyInfoDao();
        }
        applyinfo.is_install_chrg = (priceConfirm === 1 ? 0 : 1);
        dispatch(setEsApplyInfoAction(applyinfo));
        // [SAVE REDUX END]
        setPriceConfirm(priceConfirm === 1 ? 0 : 1);
    }

    const handleQuestionChange = (e) => {
        // console.log("Question : " + e.target.value);
        setQuestion(e.target.value);
        // [SAVE REDUX START]
        let applyinfo = esApplyInfo;
        if (applyinfo === null) {
            applyinfo = EsApplyInfoDao();
        }
        applyinfo.es_question = e.target.value;
        dispatch(setEsApplyInfoAction(applyinfo));
        // [SAVE REDUX END]
    }

    const hanldeAddrInput = (e) => {
        // console.log("Question : " + e.target.value);
        setAddr2(e.target.value);
        // [SAVE REDUX START]
        let applyinfo = esApplyInfo;
        if (applyinfo === null) {
            applyinfo = EsApplyInfoDao();
        }
        applyinfo.addr2 = e.target.value;
        dispatch(setEsApplyInfoAction(applyinfo));
        // [SAVE REDUX END]
    }

    return (
        <EsApplyDvryCompBlock>

            <div className="aa-btm border">
                <div className="input-box margin_b-20">
                    <div className="margin_b-40">
                        <p className="ess_text pink margin_b-10">
                            (필수) 배송정보에 따라 배송비가 차등 적용되기 때문에 중요해요. 꼭 입력해주세요.
                                            </p>

                        <div className="input_title-box margin_b-20 f-left clearfix">
                            <label htmlFor="estimatedOrderDate1" className="input-title f-left pink">희망 배송 일자</label>
                            <div className="input-content f-left">
                                <div className="clearfix" style={{ height: "40px" }}>
                                    {/* <p className="f-left p-re"> */}
                                    <DatepickerBlock focused={focused}>
                                        <SingleDatePicker
                                            id="date_input"
                                            onDateChange={onDateChange}
                                            onFocusChange={onFocusChange}
                                            focused={focused}
                                            readOnly={true}
                                            displayFormat={moment.localeData().longDateFormat('L')}
                                            monthFormat='MMMM YYYY'
                                            date={date}
                                            customInputIcon={<CustomInputIcon />}
                                            inputIconPosition="after"
                                            hideKeyboardShortcutsPanel={true}
                                        />
                                    </DatepickerBlock>
                                    <p className="info margin_t-10 f-right">
                                        ※ 확정된 날짜가 아닙니다. 희망 배송 일자이므로 업체와 상의 후 확정 지으시길 바랍니다.
                                    </p>
                                    {/* </p> */}

                                </div>

                            </div>
                        </div>

                        <div className="input_title-box clearfix">
                            <label htmlFor="hopeShipping" className="input-title f-left pink">배송 지역</label>
                            <div>
                                <div className="input-content f-left">
                                    <input type="text" className="text-input first f-left" readOnly style={{ "width": "166px" }} value={postNum} />
                                    <div className="item_input-box f-left">
                                        <input type="text" className="text-input item-input2" readOnly placeholder="기본 배송 지역에 따라 배송비가 책정됩니다." style={{ "width": "759px" }} value={addr} />
                                        <button type="button" className="input_item gray-btn" onClick={onOpenModal}>주소 찾기</button>
                                    </div>
                                    <NormalInput type="text" maxLength="20" marginBottom="40px"
                                        placeholder="상세주소" width="759px" float="right" marginInnerTop="10px"
                                        onChange={hanldeAddrInput} dispError={false} />
                                </div>

                            </div>
                            {/* <input type="text" className="text-input item-input margin_t-10 f-right" placeholder="상세주소" style={{ "width": "759px" }} /> */}

                        </div>
                    </div>

                    <div>
                        <p className="ess_text margin_b-10">
                            (선택) 판매자가 참고해서 조금 더 디테일한 견적을 낼 수 있어요.
                                            </p>

                        <div className="grid-2">
                            <div className="grid-item">
                                <div className="input_title-box margin_b-20 clearfix">
                                    <span className="input-title f-left">평수</span>
                                    <div className="input-content f-left clearfix">
                                        <div className="double_btn-box f-left" style={{ width: "170px" }}>
                                            <button type="button" className={areaType === 1 ? "active" : ""} onClick={handleAreaType}>공급</button>
                                            <button type="button" className={areaType !== 1 ? "active" : ""} onClick={handleAreaType}>전용</button>
                                        </div>
                                        <div className="default-select f-left margin_l-10" style={{ width: "200px" }}>
                                            <SelectDropDownBtn
                                                options={areaOptions}
                                                placeholder="면적을 선택하세요"
                                                onChange={handleAreaChange} />
                                        </div>
                                    </div>
                                </div>

                                <div className="input_title-box margin_b-20 clearfix">
                                    <span className="input-title f-left">주거형태</span>
                                    <div className="input-content f-left clearfix">
                                        <div className="default-select">
                                            <SelectDropDownBtn
                                                options={placeOptions}
                                                placeholder="주거형태를 선택하세요"
                                                onChange={handlePlaceChange} />
                                        </div>
                                    </div>
                                </div>

                                {/* <div className="input_title-box clearfix">
                                    <span className="input-title f-left">평면도</span>
                                    <div className="input-content f-left clearfix">
                                        <div className="f-left">
                                            <div className="clearfix margin_b-10">

                                                <div className="file_img-thumb f-left">
                                                    <img src="../assets/images/dummy/dummy-img59.jpg" alt="" />
                                                </div>

                                                <div className="file_img-thumb f-left margin_l-10">
                                                    <input type="file" id="floorPlanUpload" className="blind" />
                                                    <label htmlFor="floorPlanUpload" className="file-label"></label>
                                                </div>
                                            </div>

                                            <p className="info">
                                                ※ 가구를 배치 할 장소의 평면도를 첨부하시면 상세한 사이즈 확인이 가능합니다. (최대 2장)
                                                                </p>
                                        </div>
                                    </div>
                                </div> */}
                            </div>

                            <div className="grid-item">
                                <div className="input_title-box margin_b-20 clearfix">
                                    <span className="input-title f-left">설치 및 조립 요청</span>
                                    <div className="input-content f-left clearfix">
                                        <div className="double_btn-box">
                                            <button type="button" className={priceConfirm === 1 ? "active" : ""} onClick={handlePriceConfirm}>비용 확인해주세요</button>
                                            <button type="button" className={priceConfirm !== 1 ? "active" : ""} onClick={handlePriceConfirm}>비용 확인하지 않습니다</button>
                                        </div>
                                    </div>
                                </div>

                                <div className="input_title-box clearfix">
                                    <span className="input-title f-left">문의사항</span>
                                    <div className="input-content f-left clearfix">
                                        <TextArea placeholder="패키지 관련 문의 사항을 기입해주세요"
                                            height="160px" onChange={handleQuestionChange} />
                                        {/* // <textarea className="input-textarea" style={{ "height": "160px" }} placeholder="패키지 관련 문의 사항을 기입해주세요"></textarea> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div className="text_center" style={{ display: isBtnShow === true ? 'block' : 'none' }}>
                    <button type="button" id="delirveryApplyPrevBtn" className="s-btn gray-btn">이전</button>
                </div>


            </div>

            <Modal
                isOpen={openModal}
                onRequestClose={onCloseModal}
                style={customStyles}
                onAfterOpen={() => document.body.style.overflow = 'hidden'}
                onAfterClose={() => document.body.removeAttribute('style')}>
                <DaumPostcode
                    onComplete={handleSearchComplete} submitMode={false}/>
            </Modal>


        </EsApplyDvryCompBlock >

    );
};

export default EsApplyDvryComp;